import React,{useEffect, useState} from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import { Container, Button, Row} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { getCounterDetail, editCounter } from '../../../actions/countersActions'
import { getFarms } from '../../../actions/farmsActions'
import FormCounter from './FormCounter'
import Swal from 'sweetalert2'

export default function CounterEdit() {     
    const { t } = useTranslation()
    const {id} = useParams()
    const {counter} = useSelector(state=>state.counters)
    const {farms} = useSelector(state=>state.farms)
    const dispatch = useDispatch()

    const [formState, setFormState] = useState({})
    const {name, description, farm, reading, idCounter} = formState

    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handleEdit = async(e) => {
        e.preventDefault()

        dispatch(editCounter(name, description, farm, reading, idCounter))
        Swal.fire({
            showConfirmButton: true,
            icon: 'success',
            text: t('counters.messageedit')
        })
    }

    useEffect(()=>{
        dispatch(getCounterDetail(id))
        dispatch(getFarms())
    }, [dispatch,id])

    useEffect(() => {
        if (counter) {
            setFormState({
                name: counter.name,
                description: counter.description,
                farm: counter.farm,
                reading: counter.reading,
                idCounter: counter._id
            })
        }
    }, [counter, dispatch, id])
  
    return (
        <Container className='cuerpo'>
            <Row className="text-left custom-card-header-list">
                <Row className="custom-card-buttom">
                    <Button className="btn btn-secondary mb-4 mx-auto" href={`/admin/counters`}>
                        <i className="fas fa-arrow-circle-left"></i> {t('counters.volver')}
                    </Button>
                </Row>
                <h1>{t('counters.name')}: <span className='text-uppercase'>{counter?.name}</span></h1>
                <FormCounter submit={handleEdit} isNew={false} inputChange={handleInputChange} state={formState} farms={farms}></FormCounter>
            </Row>
        </Container>
    )
}
